'use client';
// TODO: Fix React 19 compiler lint errors. See https://react.dev/learn/react-compiler
/* eslint-disable react-hooks/set-state-in-effect */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';
import InternationalizationMenu from './Menu';
import { getLanguageFromPathname } from '@utils/pathname';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import IconType from '@ui/Icon/StaticIcon/IconType';
import { useClickOutside } from '@lib/hooks/useClickOutside';
import useIsMobile from '@lib/hooks/useIsMobile';
import useEscapeClick from '@lib/hooks/useEscapeClick';

export default function HeaderInternationalization() {
  const ref = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();
  const isMobile = useIsMobile();
  const { isEscapeClicked, setIsEscapeClicked } = useEscapeClick();

  const toggleIsOpen = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const clickOutside = useCallback(() => {
    if (!isMobile) {
      setIsOpen(false);
    }
  }, [isMobile]);

  useClickOutside(ref, clickOutside);

  useEffect(() => {
    if (isEscapeClicked && !isMobile) {
      clickOutside();
      setIsEscapeClicked(false);
    }
  }, [isEscapeClicked, setIsEscapeClicked, isMobile, clickOutside]);

  const { id } = getLanguageFromPathname(pathname);

  return (
    <div ref={ref} className="relative hidden lg:block">
      {isOpen && <InternationalizationMenu direction="down" current={id} isOpen />}
      <div className="flex h-full cursor-pointer items-center gap-2" onClick={toggleIsOpen}>
        <StaticIcon icon={IconType.languages} svgClassName="fill-body-foreground" />
      </div>
    </div>
  );
}
